import { vdkHappinessPortalApi } from "./vdk-happiness-portal-api";
const search = (command) => {
    return vdkHappinessPortalApi.post("globalsearch/search", command);
};
const GlobalSearchApi = {
    search,
};
export default GlobalSearchApi;
